import { Mail, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '../hooks/use-auth';

export function NoOrgPage() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 bg-primary-100 dark:bg-primary-900/40 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Mail className="w-8 h-8 text-primary-600 dark:text-primary-400" />
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
          You're not part of an organization yet
        </h1>

        <p className="text-gray-500 dark:text-gray-400 mb-2">
          Your account <span className="font-medium text-gray-700 dark:text-gray-300">{user?.email}</span> isn't associated with any organization.
        </p>

        <p className="text-gray-500 dark:text-gray-400 mb-8">
          Ask an organization admin to send you an invite link, then use that link to join their organization.
        </p>

        <Button variant="outline" onClick={handleLogout} className="gap-2">
          <LogOut className="w-4 h-4" />
          Sign out
        </Button>
      </div>
    </div>
  );
}
